// extracted by mini-css-extract-plugin
export default {"filters":"filters__Uwzwu","box":"box__G2Zs-","error":"error__MfS0E","header":"header__bzKvh"};